import { render, staticRenderFns } from "./UviExport.vue?vue&type=template&id=1eeb8b1e&"
import script from "./UviExport.vue?vue&type=script&lang=ts&"
export * from "./UviExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports